import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React from 'react';
export var ModalComponent = function (_React$Component) {
  _inherits(ModalComponent, _React$Component);

  function ModalComponent() {
    _classCallCheck(this, ModalComponent);

    return _possibleConstructorReturn(this, (ModalComponent.__proto__ || Object.getPrototypeOf(ModalComponent)).apply(this, arguments));
  }

  return ModalComponent;
}(React.Component);


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/es/modal/PropsType.js
// module id = 367
// module chunks = 0